import { useSiteConfig } from "@/hooks/useSiteConfig";

const Marquee = () => {
  const config = useSiteConfig();
  const items = [...config.marquee, ...config.marquee];
  return (
    <div className="relative border-y border-line bg-deep/60 py-4 overflow-hidden" aria-hidden="true" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-xs tracking-[0.3em] uppercase text-slate">
            <span className={i % 2 === 0 ? "text-mist" : "text-gold"}>{item}</span>
            <span className="mx-8 text-teal">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
